import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { cn } from '@opendoor/atoms/utils';

interface FloatingNavigationBarProps {
  activeTab: ActiveTab;
  handleOnViewBrowse?: () => void | null;
  handleOnViewFavorites?: () => void | null;
  shouldHide?: boolean | null;
}

export enum ActiveTab {
  Browse = 'browse',
  Favorites = 'favorites',
}

export const FloatingNavigationBar = ({
  activeTab,
  handleOnViewBrowse,
  handleOnViewFavorites,
  shouldHide = false,
}: FloatingNavigationBarProps) => {
  const isBrowse = activeTab === ActiveTab.Browse;
  const isFavorites = activeTab === ActiveTab.Favorites;

  return (
    <Row
      className={cn(
        'fixed left-1/2 z-5 h-17.5 w-102 -translate-x-1/2 items-center justify-center rounded-lg bg-od-bg-primary px-2.5 shadow-lg transition-[bottom] duration-300 max-md:w-52',
        shouldHide ? '-bottom-25' : 'bottom-7.5',
      )}
    >
      <Button
        variant={isBrowse ? 'secondaryInverse' : 'secondary'}
        aria-label="Browse"
        analyticsName="browse-toggle"
        onClick={handleOnViewBrowse}
        className={cn(
          'h-15 w-auto flex-1 rounded-l-lg border-0 px-3 shadow-lg',
          isBrowse ? 'rounded-r-lg' : 'rounded-r',
        )}
      >
        Browse
      </Button>
      <Button
        variant={isFavorites ? 'secondaryInverse' : 'secondary'}
        aria-label="Favorites"
        analyticsName="favorites-toggle"
        onClick={handleOnViewFavorites}
        className={cn(
          'h-15 w-auto flex-1 rounded-r-lg border-0 px-3 shadow-lg',
          isFavorites ? 'rounded-l-lg' : 'rounded-l',
        )}
      >
        Favorites
      </Button>
    </Row>
  );
};
